module.exports = __webpack_public_path__ + "img/eps.c712df3.svg";